//
//
//
//
//
//
//

export default{
  data() {
    return {

    }
  },
  created() {

  },
  methods: {

  }
}



// WEBPACK FOOTER //
// ./src/pages/build922/views/components/contact-way/index.vue